
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import MessageStatusMC from './MessageStatusMC';
import IconMC from '../../../components/IconMC';

const NoteMessageMC = React.memo(({ conversation, message }) => {
  const { t } = useTranslation('InboxMC');
  const messageText = useMemo(() => message.messageText, [message.messageText]);

  return (
    <div className="tw-wrapper">
      <div className="tw-text-yellow-600 tw-flex tw-items-center tw-justify-start tw-gap-0 tw-mb-1" role="alert">
        <IconMC name="alert-circle-outline" className="tw-h-4 tw-w-4" />
        <span className="tw-text-3xs tw-font-medium tw-ml-1">{t('messages.note_not_visible_to_customer')}</span>
      </div>
      <div className="tw-break-words tw-whitespace-pre-line tw-text-xs tw-font-normal tw-text-gray-950" dangerouslySetInnerHTML={{ __html: messageText }} />
      <MessageStatusMC message={message} platform={conversation.platform} />
    </div>
  );
});

NoteMessageMC.displayName = 'NoteMessageMC';

export default NoteMessageMC;
